const CAGlobals = {
  country: "Canada",
};

export { CAGlobals };
